import React from "react";
import { useNavigate } from "react-router-dom"; // ✅ useNavigate
import "./OurPartnersPage.css";

// Sample logos (replace with your real ones)
import logo1 from "../../Assets/partners/logo-rmbg.png";
import logo2 from "../../Assets/partners/luex.png";
import logo3 from "../../Assets/partners/hollywood.png";
import logo4 from "../../Assets/partners/myhealthcop.png";
import logo5 from "../../Assets/partners/ypo.jpeg";
import logo6 from "../../Assets/partners/psgh.jpg";
import logo7 from "../../Assets/partners/universal.png";
import logo8 from "../../Assets/partners/ministry.png";
import logo9 from "../../Assets/partners/eib.jpg";
import logo10 from "../../Assets/partners/BBC.png";
import logo11 from "../../Assets/partners/entreupr.jpeg";
import logo12 from "../../Assets/partners/tetr.jpeg";
import logo13 from "../../Assets/partners/kempinski.jpeg";

const logos = [logo1, logo2, logo3, logo4, logo5, logo6, logo7, logo8, logo9, logo10, logo11, logo12, logo13];

const OurPartnersPage = () => {
  const navigate = useNavigate(); // ✅ initialize navigate

  const handleCTA = () => {
    navigate("/contact-us"); // Update route as needed
  };

  return (
    <section className="partners-page">

      {/* HEADER */}
      <div className="partners-header">
        <h1>Trusted by Leaders & Global Partners</h1>
      </div>

      {/* MARQUEE ROW 1 */}
      <div className="marquee">
        <div className="marquee-track">
          {[...logos, ...logos].map((logo, index) => (
            <div className="logo-item" key={index}>
              <img src={logo} alt="partner logo" />
            </div>
          ))}
        </div>
      </div>

      {/* MARQUEE ROW 2 (REVERSE) */}
      <div className="marquee reverse">
        <div className="marquee-track">
          {[...logos, ...logos].map((logo, index) => (
            <div className="logo-item" key={index}>
              <img src={logo} alt="partner logo" />
            </div>
          ))}
        </div>
      </div>

      {/* CTA */}
      <div className="partners-cta">
        <h2>Partner With Us</h2>
        <p>Join us in creating meaningful and transformative experiences.</p>
        <button className="cta-btn" onClick={handleCTA}>
          Become a Partner
        </button>
      </div>

    </section>
  );
};

export default OurPartnersPage;